import { getDiaryCoverPreset } from '@pocapan/shared/utils/photoCardDiaryCoverStorage';
import './DiaryBookCover.css';

const DEFAULT_COVER_SUBTITLE = 'My collected photo cards';
const DEFAULT_COVER_BADGE = 'Collector Edition';
const BINDER_GLOSSY_IMAGE_SRC = '/assets/collections/binder_glossy.png';

export default function DiaryBookCover({
  cover,
  title,
  memberName,
  subtitle,
  ribbonText,
  badgeText,
  showBadge = true,
  titleHidden = false,
  subtitleHidden = false,
  badgeHidden = false,
  coverImageUrl,
  backgroundImage,
  backgroundColor,
  className = '',
  style,
  children
}) {
  const preset = getDiaryCoverPreset(cover?.colorId);
  const hasSavedCoverImage = !!coverImageUrl;
  const hasCustomBackgroundImage = !!backgroundImage && !hasSavedCoverImage;
  const shouldRenderGlossOverlay = !hasSavedCoverImage;
  const resolvedTitle = title ?? cover?.title ?? '';
  const resolvedSubtitle = subtitle ?? memberName ?? DEFAULT_COVER_SUBTITLE;
  const resolvedBadge = badgeText ?? DEFAULT_COVER_BADGE;
  const resolvedCoverImageAlt = resolvedTitle || resolvedSubtitle || DEFAULT_COVER_SUBTITLE;

  return (
    <div
      className={`diary-book-cover-theme ${hasCustomBackgroundImage ? 'diary-book-cover-theme--image-background' : ''} ${hasSavedCoverImage ? 'diary-book-cover-theme--saved-image' : ''} ${className}`.trim()}
      style={{
        '--diary-cover-color': preset.coverColor,
        '--diary-cover-text': preset.textColor,
        '--diary-page-color': preset.pageColor,
        '--diary-page-edge-color': preset.pageEdgeColor,
        '--diary-accent-color': preset.accentColor,
        ...style
      }}
    >
      <div className="diary-book-cover-panel">
        {hasSavedCoverImage
          ? <img
              className="diary-book-cover-saved-image"
              src={coverImageUrl}
              alt={resolvedCoverImageAlt}
              crossOrigin="anonymous"
              draggable={false}
            />
          : null}
        {!hasSavedCoverImage && (backgroundImage || backgroundColor)
          ? <div
              className="diary-book-cover-custom-background"
              style={{
                backgroundColor: backgroundColor || undefined,
                backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined
              }}
            />
          : null}
        {!hasSavedCoverImage && ribbonText
          ? <div className="diary-book-cover-ribbon">
              <div className="diary-book-cover-ribbon-text">{ribbonText}</div>
            </div>
          : null}
        {!hasSavedCoverImage
          ? <div className="diary-book-cover-copy">
              {!subtitleHidden && resolvedSubtitle
                ? <div className="diary-book-cover-subtitle">{resolvedSubtitle}</div>
                : null}
              {!titleHidden && resolvedTitle
                ? <div className="diary-book-cover-title">{resolvedTitle}</div>
                : null}
            </div>
          : null}
        {!hasSavedCoverImage && showBadge && !badgeHidden
          ? <div className="diary-book-cover-badge">{resolvedBadge}</div>
          : null}
        {shouldRenderGlossOverlay
          ? <img
              className="diary-book-cover-gloss"
              src={BINDER_GLOSSY_IMAGE_SRC}
              alt=""
              aria-hidden="true"
              draggable={false}
            />
          : null}
        {children ? <div className="diary-book-cover-overlay">{children}</div> : null}
      </div>
    </div>
  );
}
